import React, { useEffect, useState } from "react";
import {
  ClientType,
  selectAccessCodeState,
  setActiveClientsSelectedTab,
} from "../../../store/slices/clientsSlice";
import { ReactComponent as GoldenProfile } from "../../../assets/images/Profile Icon gold.svg";

import HeaderTabs from "./HeaderTabs";
import useCustomStyles from "../../../hooks/useCustomStyles";
import { activeClientInfoStyles } from "../../../assets/styles/ClientsStyles/activeClientInfoStyles";
import { useDispatch, useSelector } from "react-redux";
import { selectState } from "../../../store/slices/themeSlice";
import { selectState as selectUserState } from "../../../store/slices/authSlice";
import { selectClientState } from "../../../store/slices/clientsSlice";
import { AccessCodeType } from "../../../store/actions/accessCodeActions";
import { formatHumanReadableDate, parseDateMessage } from "../../../utils";
import { fetchUserActivity } from "../../../api/revenuCatApis";

import {
  fetchUserErrors,
  getUserTelemetry,
  TelemetryData,
} from "../../../api/awsApis";
import CustomButton from "../../../components/CustomButton";
import AddClientIDModal from "./AddClientIDModal";
import type { AppDispatch, RootState } from "../../../store/store"; // adjust path if needed
import ConnectionCollapse from "./ConnectionCollapse";
type ClientInfoCardProps = { client: ClientType; selectedTab?: string };

export type ClientActivity = {
  active_entitlements?: {
    items: {
      entitlement_id: string;
      expires_at: number;
      object: string;
    }[];
    next_page?: string | null;
    object: string;
    url: string;
  };
  experiment?: null;
  first_seen_at?: string | Date;
  id?: string;
  last_seen_at?: string | Date;
  last_seen_app_version?: string | null;
  last_seen_platform?: string | null;
  last_seen_platform_version?: string | null;
  last_seen_country?: string | null;
  object?: string;
  project_id?: string;
};

type ErrorLogData = {
  Items?: {
    __typename?: string;
    _lastChangedAt?: number;
    version?: string;
    processId?: string;
    createdAt: string | Date;
    errorResponse?: string;
    closed?: boolean;
    isUserHidden?: boolean;
    _version?: number;
    userId?: string;
    updatedAt: string | Date;
    errorMessage?: string;
    application?: string;
    id?: string;
    error?: {
      desc?: string;
    };
  }[];
  Count?: number;
  ScannedCount?: number;
};

const ActiveClientInfo: React.FC<ClientInfoCardProps> = ({
  client: clientProp,
  selectedTab: initialTab = "personal_information", //
}) => {
  const { clients } = useSelector((state: RootState) => state.clients_slice);

  //get client from clients by filtering the id and assign value to client
  const client = clients?.find((c) => c.id === clientProp.id) || clientProp;

  console.log("ActiveClientInfo client==>:", client);
  // if (!client) return null
  const dispatch = useDispatch<AppDispatch>();
  const { theme } = useSelector(selectState);
  const { user } = useSelector(selectUserState);
  const { accessCodes, contracts } = useSelector(selectAccessCodeState);
  const classes = useCustomStyles(activeClientInfoStyles, theme);
  const { subscribers } = useSelector(selectClientState);
  const [accessCodesMap, setAccessCodesMap] = useState<
    Record<string, AccessCodeType>
  >({});
  const [connections, setConnections] = useState<any[]>([]);
  const [connectionsFromProvider, setConnectionsFromProvider] = useState<any[]>(
    [],
  );
  const [userTelemetry, setUserTelemetry] = useState<TelemetryData | undefined>(
    undefined,
  );
  const [loading, setLoading] = useState(false);

  const [clientActivity, setClientActivity] = useState<ClientActivity | null>(
    null,
  );
  // const [clientSubscriptions, setClientSubscriptions] = useState<any>(null);

  const [errorLogData, setErrorLogData] = useState<ErrorLogData | null>(null);
  //const [accessCodesMap, setAccessCodesMap] = useState <Record<string, AccessCodeType>>({})
  const isElisyan = user?.business?.name === "elisyan";
  const isAurum =
    user?.business?.name === "aurum" || user?.business?.name === "aurum-test";

  // const fetchUserSubscriptionsin = async () => {
  //   try{
  //    const res = await fetchUserSubscriptions([client.app_user_id])
  //   // console.log("User subscriptions response:", res);
  //    if(res.success && res.success.length > 0){
  //     setClientSubscriptions(res.success[0]);
  //    }

  //   }catch(e){
  //    console.error("Error fetching user activity:", e);
  //   }
  // }
  const [connectionsCollapsed, setConnectionsCollapsed] = useState<
    Record<string, boolean>
  >({});
  const [subConnectionsCollapsed, setSubConnectionsCollapsed] = useState<
    Record<string, boolean>
  >({});

  const fetchUserActivityin = async () => {
    try {
      const res = await fetchUserActivity([client.app_user_id]);
      // console.log('User activity response**:', res.success[0])
      if (res.success && res.success.length > 0) {
        setClientActivity(res.success[0]);
      }
    } catch (e) {
      console.error("Error fetching user activity:", e);
    }
  };

  const fetchUserErrorsIn = async () => {
    try {
      const res = await fetchUserErrors(client.app_user_id);
      // console.log(
      //   'User Errors response:**',
      //   // res,
      //   // res.success,
      //   // res.response.items,
      //   res.response,
      // )
      if (res.success && res.success.length > 0) {
        setErrorLogData(res.response);
      }
    } catch (e) {
      console.error("Error fetching user activity:", e);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const cancelAddClientIDModal = () => {
    setIsLoading(false);
    setIsModalOpen(false);
  };
  // AddClientIDModal now dispatches assignClientId itself (both "add" a
  // first client ID and "edit"/switch to a different one go through the
  // same searchable-select + assign flow) — this just closes the modal
  // once it reports success.
  const confirmAddClientIDModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    if (client.app_user_id) {
      fetchUserActivityin();
      fetchUserErrorsIn();
      // fetchUserSubscriptionsin();
    }
  }, [client.app_user_id]);

  useEffect(() => {
    if (accessCodes) {
      const accessCodesMaptemp: Record<string, AccessCodeType> = {};
      accessCodes.forEach((element) => {
        accessCodesMaptemp[element.id] = element;
      });
      setAccessCodesMap(accessCodesMaptemp);
    }
  }, [accessCodes]);
  // Prevent rendering when status is not "pending"
  // if (client.verificationStatus !== 'active') return null
  const [selectedTab, setSelectedTab] = useState<string>(
    isAurum && initialTab === "recent_activity"
      ? "personal_information"
      : initialTab,
  );

  //  const calcTotalSpent = () => {
  //   if(!subscribers || !subscribers[client.app_user_id]) return '0 USD';
  //   const subscriptionData = Object.values(subscribers[client.app_user_id]?.subscriptions);
  //   return subscriptionData.reduce((acc, curr) => acc + (curr.total_revenue_in_usd || 0), 0) + ' USD';
  //  }

  const tabs = [
    { value: "personal_information", label: "Personal Information" },
  ];
  if (!isAurum) {
    tabs.push({ value: "subscription", label: "Subscription" });
    tabs.push({ value: "recent_activity", label: "Recent Activity" });
  }
  if (isElisyan) tabs.push({ value: "connections", label: "Connections" });
  if (isElisyan) tabs.push({ value: "error-log", label: "Error Log" });
  useEffect(() => {
    if (selectedTab === "personal_information") {
      if (
        accessCodesMap &&
        client.access_code_data.length > 0 &&
        client.access_code_data[client.access_code_data.length - 1]?.id &&
        accessCodesMap[
          client.access_code_data[client.access_code_data.length - 1]?.id
        ]?.codeType === "referral-code"
      ) {
        rows.push({
          label: "Referral",
          value:
            accessCodesMap[
              client.access_code_data[client.access_code_data.length - 1].id
            ].prefix,
        });
      }
    }
  }, [accessCodesMap]);
  // console.log('user access codes', client.access_code_data.map(i => accessCodesMap[i.id]))
  // Define the rows and their values
  let rows: { label: string | JSX.Element; value: string | undefined }[] = [];
  if (selectedTab === "personal_information") {
    rows = [
      { label: "Login Name", value: client.user_name },
      { label: "Login Email", value: client.email },
    ];
    if (
      client.pending_user_name &&
      client.pending_user_name !== client.user_name
    )
      rows.push({ label: "Name", value: client.pending_user_name });
    if (client.pending_email && client.pending_email !== client.email)
      rows.push({ label: "Email", value: client.pending_email });

    if (user?.business?.name == "elisyan") {
      rows.push({ label: "User ID", value: client.app_user_id });
      rows.push({ label: "Client ID", value: client.clientId });
    } else if (client.role_type !== "advisor") {
      rows.push({ label: "Client ID", value: client.clientId });
    }
    //  else if (client.clientId) {
    //   rows.push({ label: "Client ID", value: client.clientId });
    // }
    if (accessCodesMap[client.access_code_data[0].id]) {
      if (
        accessCodesMap[client.access_code_data[0].id].codeType ==
        "referral-code"
      ) {
        rows.push({
          label: "Referral",
          value: accessCodesMap[client.access_code_data[0].id].prefix || "",
        });
      } else {
        rows.push({
          label: "Contract",
          value: accessCodesMap[client.access_code_data[0].id].contract_ref
            ? contracts?.find(
                (contract) =>
                  contract.id ==
                  accessCodesMap[client.access_code_data[0].id].contract_ref,
              )?.contract_ref
            : "",
        });
      }
    }

    if (
      client.role_type === "advisor" &&
      client.roles &&
      client.roles.length > 0
    ) {
      rows.push({ label: "Roles", value: client.roles.join(", ") });
    }
  } else if (
    selectedTab === "subscription" &&
    subscribers &&
    client.app_user_id in subscribers
  ) {
    const activeEntitlment =
      Object.keys(subscribers[client.app_user_id].entitlements).length > 0
        ? Object.entries(subscribers[client.app_user_id].entitlements)[0]
        : null;
    const [entitlementKey, entitlementInfo] = activeEntitlment ?? ["", null];

    rows = [
      {
        label: "Activation",
        value: entitlementInfo
          ? formatHumanReadableDate(entitlementInfo.purchase_date)
          : "",
      },
      {
        label: "Expiry",
        value: entitlementInfo
          ? formatHumanReadableDate(entitlementInfo.expires_date)
          : "",
      },
      // { label: "Status", value: "Ellayon Contract" },
      // { label: "Activation", value: client.verificationStatus || "" },
      { label: "Access Code", value: client.access_code_data[0].id },
    ];
    if (client.role_type == "client") {
      rows.push({ label: "Plan", value: entitlementKey });
      rows.push({
        label: "Subscription",
        value: entitlementInfo
          ? subscribers[client.app_user_id].subscriptions[
              entitlementInfo.product_identifier
            ].display_name
            ? subscribers[client.app_user_id].subscriptions[
                entitlementInfo.product_identifier
              ].display_name
            : entitlementInfo.product_identifier
          : "",
      });
      //rows.push( { label: "Total Spent", value: entitlementInfo? `${subscribers[client.app_user_id].subscriptions[entitlementInfo.product_identifier].price.amount} ${subscribers[client.app_user_id].subscriptions[entitlementInfo.product_identifier].price.currency}`: '0 USD'})
      //rows.push( { label: "Total Spent", value: calcTotalSpent() })
    }
  } else if (
    selectedTab === "recent_activity" &&
    subscribers &&
    client.app_user_id in subscribers
  ) {
    rows = [
      {
        label: "User Since",
        value: formatHumanReadableDate(
          subscribers[client.app_user_id].first_seen,
        ),
      },
    ];
    if (clientActivity) {
      if (clientActivity.last_seen_at) {
        rows.push({
          label: "Last Activity",
          value: formatHumanReadableDate(clientActivity.last_seen_at),
        });
      }
      if (clientActivity.last_seen_app_version) {
        rows.push({
          label: "Last App Version",
          value: clientActivity.last_seen_app_version,
        });
      }
      if (clientActivity.last_seen_platform) {
        rows.push({
          label: "Device",
          value: `${clientActivity.last_seen_platform}-${clientActivity.last_seen_platform_version}`,
        });
      }
      if (clientActivity.last_seen_country) {
        rows.push({
          label: "Country",
          value: clientActivity.last_seen_country,
        });
      }
    }
    if (subscribers[client.app_user_id].original_application_version)
      rows.push({
        label: "Signup App Version ",
        value: subscribers[client.app_user_id].original_application_version,
      });
    if (userTelemetry && isElisyan) {
      rows.push({
        label: "Last Activity Time ",
        value: formatHumanReadableDate(
          new Date(userTelemetry.eventData.loginTime * 1000),
        ), // new Date().toISOString(),
      });
      rows.push({
        label: "Notifications Enabled ",
        value: userTelemetry.eventData.notificationsEnabled ? "Yes" : "No",
      });
      if (
        userTelemetry.eventData.notificationsEnabled &&
        userTelemetry.eventData.notificationsEnabled == true
      ) {
        rows.push({
          label: "Notification Categories Enabled ",
          value: userTelemetry.eventData.notificationCategoriesEnabled,
        });
      }
      if (userTelemetry.eventData.lastReceivedNotification) {
        // const {date, message} = parseDateMessage(userTelemetry.eventData.lastReceivedNotification)
        // let formattedDate = undefined
        // if(date){
        //   formattedDate = formatHumanReadableDate(date)
        // }
        rows.push({
          label: "Last Received Notification ",
          value: userTelemetry.eventData.lastReceivedNotification,
        });
      }

      if (userTelemetry.eventData.preferences) {
        const prefs = userTelemetry.eventData.preferences;

        const currencies = [
          prefs.primaryCurrency,
          prefs.additionalCurrency1,
          prefs.additionalCurrency2,
        ]
          .filter(Boolean)
          .join(", ");
        if (currencies) {
          rows.push({ label: "Currencies", value: currencies });
        }

        const taxResidencies = [
          prefs.primaryTaxResidency,
          prefs.additionalTaxResidency1,
          prefs.additionalTaxResidency2,
        ]
          .filter(Boolean)
          .join(", ");
        if (taxResidencies) {
          rows.push({ label: "Tax Residencies", value: taxResidencies });
        }

        rows.push({
          label: "FBAR Enabled",
          value: prefs.activeFbar ? "Yes" : "No",
        });
        rows.push({
          label: "Geo Monitor Enabled",
          value: prefs.activeGeoMonitor ? "Yes" : "No",
        });
      }
      if (userTelemetry?.eventData?.grantedLocationPermission) {
        rows.push({
          label: "Location Permission Granted",
          value: userTelemetry.eventData.grantedLocationPermission
            ? "Yes"
            : "No",
        });
      }
    }
  } else if (selectedTab === "error-log") {
    rows = [];
    // if (errorLog && errorLog[client.app_user_id]) {
    //     [...errorLog[client.app_user_id]] // Create a shallow copy of the array
    //         .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()) // Sort by createdAt
    //         .map(error =>
    //             rows.push({
    //                 label: formatHumanReadableDate(error.createdAt),
    //                 value: `${error.errorMessage} ${error.error.desc ? '-' + error.error.desc : ''}`
    //             })
    //         );
    // }
    if (errorLogData && errorLogData.Items && errorLogData.Items.length > 0) {
      [...errorLogData.Items] // Create a shallow copy of the array
        .sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
        ) // Sort by createdAt
        .map((error) =>
          rows.push({
            //   label: `<FaGithub className="github-icon" />${formatHumanReadableDate(
            //     error.createdAt,
            //  )}-${error.version}`,

            label: (
              <>
                {error.isUserHidden === true && (
                  <span style={{ marginRight: 5, color: "green" }}>
                    <i className="fa fa-eye-slash" aria-hidden="true" />
                  </span>
                )}
                {error.isUserHidden === false && (
                  <span style={{ marginRight: 5, color: "red" }}>
                    <i className="fa fa-eye" aria-hidden="true" />
                  </span>
                )}
                {formatHumanReadableDate(error.createdAt)}-{error.version}
              </>
            ),
            value: `${error?.errorMessage} ${
              error?.error?.desc ? "-" + error.error.desc : ""
            }`,
          }),
        );
    }
  }

  //useEffect(() => {console.log('errorLogdata', errorLogData)},[errorLogData])
  useEffect(() => {
    const fetchTelemetry = async () => {
      if (!client?.app_user_id) return;

      setLoading(true);

      try {
        const { connections, connectionsFromProvider, userTelemetry } =
          await getUserTelemetry(client.app_user_id);

        setConnections(connections);
        setConnectionsFromProvider(connectionsFromProvider);
        setUserTelemetry(userTelemetry);
        console.log("userTelemetry", userTelemetry);
        console.log("connections", connections);
        console.log("connectionsFromProvider", connectionsFromProvider);
      } catch (err) {
        console.error("Error fetching telemetry:", err);
      } finally {
        setLoading(false);
      }
    };
    if (isElisyan || isAurum) {
      fetchTelemetry();
    }
  }, [client.app_user_id]);
  const handleTabChange = (tab: string) => {
    setSelectedTab(tab);
    dispatch(setActiveClientsSelectedTab(tab));
  };
  return (
    <div className={classes.container}>
      <HeaderTabs
        tabs={tabs}
        selectedTab={selectedTab}
        onSelect={handleTabChange}
      />

      {/* <div className={classes.innerContainer}>
        {selectedTab === "personal_information" && (
          <div className={classes.iconWrapper}>
            <GoldenProfile width={75} height={75} />
            {client.role_type === "advisor" ? null : (
              <div className={classes.buttonContainer}>
                <CustomButton
                  title={client.clientId ? "Edit Client ID" : "Add Client ID"}
                  handleClick={() => !isLoading && setIsModalOpen(true)}
                  name={""}
                  loading={isLoading}
                  variant="secondary"
                />
              </div>
            )}
          </div>
        )}
        <div
          style={{
            // padding: "0px 10px",
            padding: selectedTab === "personal_information" ? "10px 20px" : 0,

            minWidth: "50px",
            display: "flex",
            flexDirection: "row",
            width: "100%",
            whiteSpace: "nowrap",
            WebkitOverflowScrolling: "touch", // smooth swipe on iOS
            scrollbarWidth: "thin",
            overflowX: "auto",
            overflowY: "auto",
            minHeight: "30vh",
            maxHeight: "80vh",
            position: "relative", // required for sticky positioning
          }}
        >
          <table className={classes.table}>
            <tbody>
              {rows.map((row, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 1 ? "#fff" : " #F6F6F6", // White for even, red for odd
                    // borderBottom: "1px solid #eee",
                    maxHeight: "10",
                  }}
                >
                  <td className={classes.labelCell}>{row.label}</td>
                  <td className={classes.valueCell}>{row.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div> */}
      <div className={classes.innerContainer}>
        {selectedTab === "connections" ? (
          <div
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 16,
            }}
          >
            {connections.length == 0 && connectionsFromProvider.length == 0 && (
              <p className={classes.headerText}>No connections found</p>
            )}
            <ConnectionCollapse connections={connections} isFromApp={true} />
            <ConnectionCollapse connections={connectionsFromProvider} />
          </div>
        ) : selectedTab === "personal_information" ? (
          <>
            <div className={classes.iconWrapper}>
              <GoldenProfile width={75} height={75} />
              {client.role_type === "advisor" ? null : (
                <div className={classes.buttonContainer}>
                  <CustomButton
                    title={client.clientId ? "Edit Client ID" : "Add Client ID"}
                    handleClick={() => !isLoading && setIsModalOpen(true)}
                    name={""}
                    loading={isLoading}
                    variant="secondary"
                  />
                </div>
              )}
            </div>
            <div
              style={{
                // padding: "0px 10px",
                padding:
                  selectedTab === "personal_information" ? "10px 20px" : 0,

                minWidth: "50px",
                display: "flex",
                flexDirection: "row",
                width: "100%",
                whiteSpace: "nowrap",
                WebkitOverflowScrolling: "touch", // smooth swipe on iOS
                scrollbarWidth: "thin",
                overflowX: "auto",
                overflowY: "auto",
                minHeight: "30vh",
                maxHeight: "80vh",
                position: "relative", // required for sticky positioning
              }}
            >
              <table className={classes.table}>
                <tbody>
                  {rows.map((row, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 1 ? "#fff" : " #F6F6F6", // White for even, red for odd
                        // borderBottom: "1px solid #eee",
                        maxHeight: "10",
                      }}
                    >
                      <td className={classes.labelCell}>{row.label}</td>
                      <td className={classes.valueCell}>{row.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div
            style={{
              // padding: "0px 10px",
              padding: selectedTab === "personal_information" ? "10px 20px" : 0,

              minWidth: "50px",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              whiteSpace: "nowrap",
              WebkitOverflowScrolling: "touch", // smooth swipe on iOS
              scrollbarWidth: "thin",
              overflowX: "auto",
              overflowY: "auto",
              minHeight: "30vh",
              maxHeight: "80vh",
              position: "relative", // required for sticky positioning
            }}
          >
            <table className={classes.table}>
              <tbody>
                {rows.map((row, index) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 1 ? "#fff" : " #F6F6F6", // White for even, red for odd
                      // borderBottom: "1px solid #eee",
                      maxHeight: "10",
                    }}
                  >
                    <td className={classes.labelCell}>{row.label}</td>
                    <td className={classes.valueCell}>{row.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {/* {selectedTab === "subscription" && (
        <MultiSelectGrid label={"App Features"} items={itemList} />
      )}
      {selectedTab === "recent_activity" && (
        <HistoryClientActivityTable data={historyData} />
      )} */}

      <AddClientIDModal
        isOpen={isModalOpen}
        onConfirm={confirmAddClientIDModal}
        onCancel={cancelAddClientIDModal}
        client={client}
      />
    </div>
  );
};

export default ActiveClientInfo;
